"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var mapPoints = function mapPoints(ePremia) {
  return {
    availablePoints: ePremia.balance,
    lockedPoints: ePremia.balance_locked,
    history: ePremia.history.map(function (history) {
      return mapEPointsHistory(history);
    }).sort(function (current, next) {
      return new Date(next.date) - new Date(current.date);
    })
  };
};
var mapEPointsHistory = function mapEPointsHistory(history) {
  return history !== null && history !== void 0 && history.email ? {
    date: history.date,
    email: history.email,
    action: history.action,
    event: history.event
  } : {
    date: history.order_date,
    order: history.order,
    action: history.action,
    event: history.event,
    points: history.points
  };
};
var _default = mapPoints;
exports["default"] = _default;